import { TActions } from '../../../AppModulesWrapper';

import { ETopBetsStatus, ITopBetsState } from '../../types/reducers/topBets';
import { initDefaultState } from './initDefaultState';
import { LOAD_TOP_BETS_FAIL, LOAD_TOP_BETS_START, LOAD_TOP_BETS_SUCCESS } from '../../actions/topBets';
import { RESET_STATE } from '../../actions/resetState';

export function topBets(state: ITopBetsState = initDefaultState(), action: TActions): ITopBetsState {
  switch (action.type) {
    case LOAD_TOP_BETS_START: {
      return {
        ...state,
        status: ETopBetsStatus.pending,
        errorCode: null,
      };
    }

    case LOAD_TOP_BETS_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        status: ETopBetsStatus.success,
      };
    }

    case LOAD_TOP_BETS_FAIL: {
      return {
        ...state,
        status: ETopBetsStatus.fail,
        errorCode: action.payload,
      };
    }

    case RESET_STATE:
      return {
        ...initDefaultState(),
      };

    default:
      return state;
  }
}
